const NO_ACCESS_TOKEN = "NO_ACCESS_TOKEN";
const CUSTOMER_IS_NOT_ENABLED = "CUSTOMER_IS_NOT_ENABLED";
const NO_CUSTOMER = "NO_CUSTOMER";
const NO_LTI = "NO_LTI";
const LICENSE_EXPIRED = "LICENSE_EXPIRED";
const NO_LEARNER_EMAIL_AVAILABLE = "NO_LEARNER_EMAIL_AVAILABLE";
const NO_LEARNER_NAME_AVAILABLE = "NO_LEARNER_NAME_AVAILABLE";
const NOT_FOUND = "NOT_FOUND";
const USER_HASNT_FINISHED_WATCHING_THE_COURSE = "USER_HASNT_FINISHED_WATCHING_THE_COURSE";
const GENERIC_ERROR_MESSAGE = "GENERIC_ERROR_MESSAGE";
const DYNAMIC_REGISTRATION_NOT_ENABLED = "DYNAMIC_REGISTRATION_NOT_ENABLED";
const DEEP_LINKING_NOT_ENABLED = "DEEP_LINKING_NOT_ENABLED";
const ERROR_IN_LTI_AUTH = "ERROR_AT_LTI_HANDSHAKE";
const COURSE_STATUS_ARCHIVED = "COURSE_STATUS_ARCHIVED";
const COURSE_STATUS_EXPIRED = "COURSE_STATUS_EXPIRED";
const COURSE_NOT_FOUND = "COURSE_NOT_FOUND";

type ErrorType
  = typeof NO_ACCESS_TOKEN
    | typeof CUSTOMER_IS_NOT_ENABLED
      | typeof NO_CUSTOMER
        | typeof NO_LTI
          | typeof LICENSE_EXPIRED
            | typeof NO_LEARNER_EMAIL_AVAILABLE
              | typeof NO_LEARNER_NAME_AVAILABLE
                | typeof NOT_FOUND
                 | typeof USER_HASNT_FINISHED_WATCHING_THE_COURSE
                  | typeof GENERIC_ERROR_MESSAGE
                  | typeof DYNAMIC_REGISTRATION_NOT_ENABLED
                  | typeof DEEP_LINKING_NOT_ENABLED
                  | typeof ERROR_IN_LTI_AUTH
                  | typeof COURSE_STATUS_ARCHIVED
                  | typeof COURSE_STATUS_EXPIRED
                  | typeof COURSE_NOT_FOUND;

type ErrorPageParams = {
                  errorToken: ErrorType;
}
export type {ErrorType, ErrorPageParams};
export {
        NO_ACCESS_TOKEN, 
        CUSTOMER_IS_NOT_ENABLED, 
        NO_CUSTOMER, 
        NO_LTI, 
        LICENSE_EXPIRED, 
        NO_LEARNER_EMAIL_AVAILABLE,
        NO_LEARNER_NAME_AVAILABLE, 
        NOT_FOUND, 
        USER_HASNT_FINISHED_WATCHING_THE_COURSE, 
        GENERIC_ERROR_MESSAGE, 
        DYNAMIC_REGISTRATION_NOT_ENABLED, 
        DEEP_LINKING_NOT_ENABLED, 
        ERROR_IN_LTI_AUTH,COURSE_STATUS_ARCHIVED,
        COURSE_STATUS_EXPIRED,
        COURSE_NOT_FOUND
};
